import { useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from '../header/Header';
import SidebarLayout from '../sidebar/Sidebar';
import RoutesMap from '../../route_control/RouteControl';
import { SessionManager, showAccessDeniedAlert } from '../../utils';

const useAuth = () => {
    let user = SessionManager.getCookie("user_token");

    if (user) {
        try {
            if (user) {
                return user;
            }
        } catch (error) {
            return false
        }
    } else {
        return false
    }
}

const Auth = (props) => {
    const [collapsed, setCollapsed] = useState(false)
    const auth = useAuth()
    const navigate = useNavigate()
    const location = useLocation()
    var permission = JSON.parse(SessionManager.getSession('permission'))

    const isRouteAuthorized = permission && permission.some(
        (item) => item.route === location.pathname
    );

    if (!auth) {
        return <Navigate to={RoutesMap?.LOGIN?.path} />
    }
    else if (!isRouteAuthorized) {
        if (auth && location.pathname === '/') {
            return <Navigate to={RoutesMap?.DASHBOARD?.path} />
        } else {
            showAccessDeniedAlert(navigate)
            return null;
        }
    }
    else {
        return (
            <div>
                <Header collapsed={collapsed} setCollapsed={setCollapsed} />
                <SidebarLayout collapsed={collapsed} setCollapsed={setCollapsed} />
                <div className={collapsed ? "outlet_collapsed" : "outlet_not_collapsed"}>
                    <Outlet />
                </div>
            </div>
        )
    }
}

export default Auth;